module.exports = __webpack_public_path__ + "static/media/cypher.25ee9309.png";